const slotenmakerEindhoven = {
  seo: {
    title: "Slotenmaker Eindhoven | 24/7 Spoed, Vaste Prijs",
    description:
      "Slotenmaker nodig in Eindhoven ? Buitengesloten, slot kapot of inbraakschade ? Wij komen 24/7 met spoedservice. Vaste prijzen, SKG-gecertificeerd.",
  },

  breadcrumb: {
    home: "Home",
    current: "Slotenmaker Eindhoven",
  },

  hero: {
    badge: "24/7 SPOEDSERVICE — EINDHOVEN",
    h1: "Slotenmaker Eindhoven — 24/7 spoedservice",
    subtitle:
      "Buitengesloten, slot defect of na een inbraak ? Onze slotenmaker komt 24/7 in heel Eindhoven. Vaste prijs vooraf, SKG-gecertificeerd.",
    ctaCall: "Bel nu 06 38 27 20 35",
    ctaForm: "Of stuur een bericht",
    usp1: "24/7 echt bereikbaar",
    usp2: "Vaste prijs vooraf",
    usp3: "SKG-gecertificeerd",
  },

  wanneer: {
    h2: "Wanneer heeft u een slotenmaker nodig ?",
    intro:
      "Een slotenmaker bellen is nooit leuk, maar soms onvermijdelijk. Wij helpen bij elke situatie waarin uw slot of deur niet functioneert zoals het hoort. Onze slotenmaker in Eindhoven staat dag en nacht voor u klaar.",
    items: [
      {
        title: "Buitengesloten",
        text: "Sleutel vergeten, op slot gevallen of sleutel kwijt ? Wij openen uw deur zonder schade aan het slot of de deur. In de meeste gevallen binnen 30 tot 60 minuten ter plaatse in Eindhoven.",
      },
      {
        title: "Slot kapot of klemt",
        text: "Draait de sleutel niet meer soepel, klemt het slot of zit het cilindermechanisme vast ? Onze slotenmaker repareert of vervangt het slot ter plaatse. We werken met SKG-gecertificeerde cilinders van alle gangbare merken.",
      },
      {
        title: "Sleutel afgebroken in slot",
        text: "Een afgebroken sleutel in het slot is frustrerend, maar geen probleem voor ons. Wij verwijderen de sleutelresten professioneel en controleren of het slot nog goed functioneert. Indien nodig vervangen we het cilinder direct.",
      },
      {
        title: "Na inbraak slot vervangen",
        text: "Na een inbraak is het zaak om snel de beveiliging te herstellen. Wij plaatsen direct SKG***-gecertificeerde cilinders en nieuw hang- en sluitwerk. Ook voor noodbeveiliging en tijdelijke reparatie bent u bij ons aan het juiste adres.",
      },
      {
        title: "Cilinder vervangen na verhuizing",
        text: "Na verhuizing of verlies van sleutels is het verstandig om de cilinder te vervangen. Zo weet u zeker dat niemand ongeautoriseerd toegang heeft. Wij monteren direct een nieuwe SKG-gecertificeerde cilinder met meerdere sleutels.",
      },
      {
        title: "Inbraakpreventie",
        text: "Wilt u de beveiliging van uw woning of bedrijf verhogen ? Onze slotenmaker adviseert over SKG***-cilinders, anti-kerntrekbeslag, kierstandhouders en bijzetsloten. Zo maakt u het inbrekers een stuk lastiger.",
      },
    ],
  },

  diensten: {
    h2: "Onze slotenmaker diensten in Eindhoven",
    intro:
      "Als slotenmaker in Eindhoven bieden wij een compleet pakket aan slotenmaker diensten. Van spoedopeningen tot preventieve beveiliging — wij regelen het allemaal met vaste prijzen en professioneel gereedschap.",
    items: [
      {
        title: "Openen zonder schade",
        text: "Buitengesloten ? Wij openen uw deur professioneel en zonder schade aan het slot of kozijn. Onze slotenmaker in Eindhoven gebruikt gespecialiseerde gereedschappen die passen bij uw type slot. Meeste deuren zijn binnen enkele minuten open.",
      },
      {
        title: "Slot vervangen en repareren",
        text: "Is uw slot defect, versleten of na een inbraak beschadigd ? Wij vervangen het complete slot inclusief nieuwe cilinder en beslag. Ook repareren wij klemmende sloten, loszittende scharnieren en sluitwerk dat niet meer goed afsluit.",
      },
      {
        title: "Cilinder vervangen SKG***",
        text: "Wij vervangen cilinders door SKG***-gecertificeerde exemplaren van M&C, Mauer, ABUS, DOM, Nemef en Lips. Een SKG*** cilinder biedt maximale inbraakwerendheid en voldoet aan de eisen van verzekeraars. Lees meer over cilindervervanging.",
        linkText: "Lees meer over cilinders",
        linkHref: "/slot-cilinder-vervangen/",
      },
      {
        title: "Inbraakschade slot herstel",
        text: "Na een inbraak is snelheid essentieel. Wij herstellen geforceerde sloten, vervangen beschadigd hang- en sluitwerk en plaatsen direct noodbeveiliging. Ook regelen wij het schaderapport voor uw verzekeraar.",
        linkText: "Inbraakschade reparatie",
        linkHref: "/inbraakschade-reparatie/",
      },
      {
        title: "Hang- en sluitwerk upgraden",
        text: "Uw huidige sloten voldoen mogelijk niet meer aan de huidige veiligheidseisen. Wij upgraden uw hang- en sluitwerk naar SKG-gecertificeerde componenten : anti-kerntrekbeslag, verstevigde scharnieren en extra sluitpunten.",
      },
      {
        title: "Bijzetsloten en kierstandhouders",
        text: "Een bijzetslot of kierstandhouder is een eenvoudige maar effectieve aanvulling op uw bestaande beveiliging. Wij adviseren welk type het beste past bij uw deur en monteren het direct professioneel.",
      },
    ],
  },

  spoed: {
    h2: "24/7 spoedservice in heel Eindhoven",
    intro:
      "Onze slotenmaker in Eindhoven is 24 uur per dag, 7 dagen per week bereikbaar — ook 's nachts, in het weekend en op feestdagen. Wij komen binnen 30 tot 60 minuten ter plaatse in de meeste wijken van Eindhoven.",
    points: [
      "Binnen 30-60 minuten ter plaatse in Eindhoven Centrum, Strijp, Woensel, Gestel en omstreken",
      "Ook beschikbaar 's nachts, in het weekend en op feestdagen zonder toeslag",
      "Vaste voorrijprijs — geen verrassingen achteraf",
      "Werkgebied : alle wijken Eindhoven, Veldhoven, Geldrop en directe omgeving",
      "Altijd een vaste prijsopgave telefonisch vooraf",
    ],
    note: "Bel direct voor spoed : onze slotenmaker in Eindhoven staat voor u klaar. Geen woekertarieven, geen verborgen kosten.",
  },

  prijzen: {
    h2: "Wat kost een slotenmaker in Eindhoven ?",
    intro:
      "Transparante prijzen zonder woekertarieven. Bij ons krijgt u altijd vooraf een vaste prijsopgave telefonisch. Zo weet u precies waar u aan toe bent, zonder verrassingen achteraf.",
    rows: [
      { label: "Openen deur overdag (ma-vr 08:00-18:00)", value: "vanaf €75" },
      { label: "Openen deur nacht / weekend / feestdagen", value: "vanaf €125" },
      { label: "Slot vervangen inclusief nieuw slot", value: "€85 — €175" },
      { label: "Cilinder SKG*** (inclusief montage)", value: "€45 — €125 per cilinder" },
      { label: "Cilinder vervangen na inbraak (spoed)", value: "€65 — €145" },
      { label: "Bijzetslot monteren", value: "€95 — €165" },
      { label: "Kierstandhouder plaatsen", value: "€65 — €95" },
      { label: "Voorrijkosten", value: "gratis binnen 15 km van Eindhoven" },
    ],
    note: "Altijd vaste prijs vooraf telefonisch. Nooit achteraf meer betaald dan afgesproken.",
  },

  waarom: {
    h2: "Waarom onze slotenmaker ?",
    intro:
      "Kiezen voor onze slotenmaker in Eindhoven betekent kiezen voor betrouwbaarheid, transparantie en vakmanschap. Wij doen wat we zeggen en zeggen wat we doen.",
    items: [
      {
        title: "24/7 echt bereikbaar",
        text: "Wij nemen elke oproep serieus, dag en nacht. Geen wachttijden van uren — onze slotenmaker komt direct.",
      },
      {
        title: "Vaste prijzen — geen woeker",
        text: "Wij werken met transparante, vaste prijzen. Vooraf telefonisch een duidelijke prijsopgave. Geen verborgen kosten, geen woekertarieven.",
      },
      {
        title: "SKG-gecertificeerd werk",
        text: "Al ons hang- en sluitwerk voldoet aan SKG-keurmerk eisen. Uw verzekeraar accepteert ons werk en u woont veiliger.",
      },
      {
        title: "Lokaal en snel ter plaatse",
        text: "Wij zijn gevestigd in Eindhoven en kennen elke wijk. Dat betekent een korte aanrijtijd en een slotenmaker die snel bij u is.",
      },
      {
        title: "Identificatie verplicht",
        text: "Uw veiligheid staat voorop. Onze slotenmaker vraagt altijd naar legitimatie om te verifiëren dat u de eigenaar of bewoner bent. Zo werken wij veilig en verantwoord.",
      },
    ],
  },

  faq: {
    h2: "Veelgestelde vragen slotenmaker Eindhoven",
    items: [
      {
        q: "Hoe snel is de slotenmaker er in Eindhoven ?",
        a: "In de meeste wijken van Eindhoven zijn wij binnen 30 tot 60 minuten ter plaatse. Centrum, Strijp, Woensel, Gestel en Veldhoven worden het snelst bediend. Bel direct en wij geven u een exacte tijdsindicatie.",
      },
      {
        q: "Wat kost een slotenmaker als ik buitengesloten ben ?",
        a: "Het openen van een deur overdag (maandag tot vrijdag 08:00-18:00) kost vanaf €75. 's Avonds, in het weekend of op feestdagen vanaf €125. Wij geven altijd vooraf een vaste prijsopgave telefonisch, zodat u precies weet wat u betaalt.",
      },
      {
        q: "Komen jullie ook 's nachts en in het weekend ?",
        a: "Ja, onze slotenmaker in Eindhoven is 24 uur per dag, 7 dagen per week beschikbaar. Ook 's nachts, in het weekend en op feestdagen. Wij rekenen geen woekertarieven — de prijs is transparant en vooraf afgesproken.",
      },
      {
        q: "Openen jullie het slot zonder schade ?",
        a: "Ja, wij openen de meeste deuren zonder schade aan het slot of kozijn. Onze slotenmaker gebruikt gespecialiseerde gereedschappen die passen bij uw type slot. In zeer zeldzame gevallen kan het slot beschadigd raken, maar dan overleggen wij dit altijd met u voordat we verdergaan.",
      },
      {
        q: "Moet ik bewijzen dat ik de bewoner ben ?",
        a: "Ja, om veiligheidsredenen vragen wij altijd om een geldig identiteitsbewijs. Dit is verplicht bij elke spoedopening. Zonder legitimatie openen wij geen deuren. Zo beschermen wij zowel u als onze slotenmaker tegen misbruik.",
      },
      {
        q: "Zijn jullie cilinders SKG-gecertificeerd ?",
        a: "Ja, wij monteren uitsluitend SKG***-gecertificeerde cilinders van gerenommeerde merken zoals M&C, Mauer, ABUS, DOM, Nemef en Lips. Een SKG*** cilinder voldoet aan de strengste inbraakwerendheidsnormen en wordt geaccepteerd door verzekeraars.",
      },
      {
        q: "Rekenen jullie achteraf meer ?",
        a: "Nee, bij ons betaalt u nooit meer dan vooraf afgesproken. Wij werken met vaste prijzen die telefonisch worden bevestigd. Geen verborgen kosten, geen extra toeslagen achteraf. Transparantie is ons uitgangspunt.",
      },
      {
        q: "Vervangen jullie sloten na een inbraak ?",
        a: "Ja, na een inbraak vervangen wij direct alle geforceerde sloten en cilinders. Wij plaatsen SKG***-gecertificeerde vervangingen, regelen noodbeveiliging en maken een schaderapport voor uw verzekeraar. Ook voor inbraakschade aan kozijnen en deuren helpen wij u direct.",
      },
    ],
  },

  ctaBanner: {
    h2: "Slotenmaker nodig in Eindhoven ? Bel direct 24/7 !",
    cta: "06 38 27 20 35",
    label: "Direct een slotenmaker aan de lijn",
  },

  links: {
    h2: "Meer over onze diensten",
    cards: [
      {
        title: "Cilinder vervangen",
        desc: "SKG***-cilinders van alle merken. Vervanging na verhuizing, inbraak of sleutelverlies.",
        href: "/slot-cilinder-vervangen/",
      },
      {
        title: "Inbraakschade reparatie",
        desc: "Direct herstel na inbraak. Noodbeveiliging, slotvervanging en verzekeringsrapport.",
        href: "/inbraakschade-reparatie/",
      },
      {
        title: "Kozijnreparatie",
        desc: "Houten, kunststof en aluminium kozijnen repareren in Eindhoven en omstreken.",
        href: "/kozijn-reparatie/",
      },
      {
        title: "Glas vervangen",
        desc: "Enkel, dubbel en HR++ glas. Spoedvervanging mogelijk.",
        href: "/glas-vervangen/",
      },
    ],
  },
};

export default slotenmakerEindhoven;